import Parse from 'parse';

import { Injectable } from '@angular/core';

import { LabelTopology, ParseBaseRepository } from '@telespot/infrastructure/parse';
import { type LabelRepository } from '@telespot/protocols/domain';
import { Label } from '../state';

@Injectable({
  providedIn: 'root',
})
export class TelespotLabelService extends ParseBaseRepository implements LabelRepository {
  constructor() {
    super(Parse, { useMasterKey: false });
  }

  public async fetchByUuid(uuids: string[]): Promise<Label[]> {
    const labelQuery = new Parse.Query(LabelTopology.TABLE).containedIn(LabelTopology.UUID, uuids);
    const parseLabels = this.getTokenPaginationGenerator({ query: labelQuery, limit: 50 });
    return this.toLabels(parseLabels, uuids);
  }

  private async toLabels(generator: AsyncGenerator<Parse.Object[]>, order: string[]) {
    const labels = new Map<string, Label>();

    for await (const items of generator) {
      for (const item of items) {
        const id = item.get(LabelTopology.UUID);
        const language = item.get(LabelTopology.LANG);

        const label = labels.get(id) ?? ({ id, aliases: {} } as Label);

        label.aliases[language] = {
          id,
          name: item.get(LabelTopology.VALUE),
          language,
        };

        labels.set(id, label);
      }
    }

    return order.map((uuid) => labels.get(uuid));
  }
}
